"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Constraint_1 = require("./Constraint");
/**
 * RangeConstraint representation.
 *
 * @author RV
 */


var RangeConstraint =
/*#__PURE__*/
function (_Constraint_1$Constra) {
  _inherits(RangeConstraint, _Constraint_1$Constra);

  /**
   * @param range the range specification
   */
  function RangeConstraint(range) {
    var _this;

    _classCallCheck(this, RangeConstraint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeConstraint).call(this));
    _this.range = range;
    return _this;
  }

  return RangeConstraint;
}(Constraint_1.Constraint);

exports.RangeConstraint = RangeConstraint;